// extracted by mini-css-extract-plugin
module.exports = {"root":"AlbumCard_root__3l-NA","info":"AlbumCard_info__1MYAE","name":"AlbumCard_name__1rzmg","artist":"AlbumCard_artist__2MpO9"};